const localPrefixes = ['veluvit:studio-renew', 'veluvit:creator-quest-claim:']
const sessionPrefixes = [
  'veluvit:import:',
  'veluvit:portrait:',
  'veluvit:author-test:',
]

function removeKeys(storage: Storage, prefixes: string[]) {
  try {
    for (let i = storage.length - 1; i >= 0; i -= 1) {
      const key = storage.key(i)
      if (key && prefixes.some((prefix) => key.startsWith(prefix)))
        storage.removeItem(key)
    }
  } catch {}
}

export function clearLegacyStudioStorage() {
  try {
    removeKeys(localStorage, localPrefixes)
  } catch {}
  try {
    removeKeys(sessionStorage, sessionPrefixes)
  } catch {}
  try {
    indexedDB.deleteDatabase('veluvit-studio-renew-backup')
  } catch {}
}
